<template>
  <div>
    <Orbit :elements="people" />
  </div>
</template>

<script>
import * as DATA from './data.js'
import Orbit from './components/Orbit.vue'

export default {
  name: 'App',
  components: {
    Orbit
  },
  data () {
    return {
      people: []
    }
  },
  mounted () {
    let sorted = {}
    DATA.people.forEach(p => {
      if (Object.keys(sorted).includes(p.distance.toString())) {
        sorted[p.distance].push(p)
      }
      else {
        sorted[p.distance] = [p]
      }
    })
    console.log(sorted)
    this.people = sorted
  }
}
</script>

<style>
</style>
